import { TextInput } from './text.mjs';
import { registerCustomElement } from '../utils.mjs';
import { cast } from '../types/number.mjs';

export class NumberInput extends TextInput {
	castValue(value) {
		return cast(value);
	}

	set value(value) {
		super.value = value;
	}

	get value() {
		const value = super.value;

		return this.isCoder() ? value : this.castValue(value);
	}
}

registerCustomElement('imt-input-number', NumberInput);
